<template xmlns="http://www.w3.org/1999/html">
  <SOSlotModal
      modal-title="Matikan Mesin"
      :modal-id="id"
      @close="close"
  >
    <template v-slot:modal-body>
      <div class="f-c-black f-regular f-14">
        <div>Mesin ini tidak bisa menerima transaksi sampai dinyalakan kembali. Yakin ingin matikan mesin?</div>

        <div class="mt-4">*Pastikan mesin tidak sedang menjalankan transaksi, karena transaksi akan berhenti jika mesin mati.</div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <SOButton
          :outline-danger="true"
          :loading="loading"
          :full="true"
          text="Ya, Matikan Mesin"
          @action="turnOff"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
export default {
  name: "SnapMesinModalTurnOff",
  components: {SOButton, SOSlotModal},
  props: {
    idMesin: String
  },
  data() {
    return {
      id: "modal-turnoff",
      loading: false
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async turnOff(){
      this.loading = true
      await this.$store.dispatch("snapMesinModule/turnOffMesin", this.idMesin)
      this.loading = false
      await this.close();
    }
  },
  mounted() {
    $("#"+this.id).modal("show")
  }
}
</script>

<style scoped>

</style>